import { c as _c } from "react/compiler-runtime";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import debounce from "lodash-es/debounce";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { RoomDataType, RoomPropertyResponseType } from "./index.types";
export const useRoomPageTracking = (roomData, roomProperty) => {
  const $ = _c(8);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== roomData || $[1] !== router) {
    t0 = () => {
      if (!roomData) {
        return;
      }
      const debouncedTrackEvent = debounce(() => {
        addEventToTracking(USER_TRACKING_EVENTS.PAGE_VISIT_PROPERTY, {
          product: "villa",
          date_from: new Date(router.query.date_from as string),
          date_to: new Date(router.query.date_to as string),
          passenger_no: toNumber(router.query.room_capacity) || 0,
          region: roomData.property?.city?.title,
          region_id: toString(roomData.property?.city?.id),
          property_name: roomData.property?.title,
          property_id: roomData?.property?.id
        });
      }, 500);
      debouncedTrackEvent();
      return () => {
        debouncedTrackEvent.cancel();
      };
    };
    t1 = [roomData, router];
    $[0] = roomData;
    $[1] = router;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== roomData || $[5] !== roomProperty || $[6] !== router) {
    const handleTrackReserveButtonClicked = () => {
      addEventToTracking(USER_TRACKING_EVENTS.RESERVE_BUTTON_CLICKED, {
        product: "villa",
        date_from: new Date(router.query.date_from as string),
        date_to: new Date(router.query.date_to as string),
        city: roomData.property?.city?.title,
        city_id: roomData.property?.city?.id,
        hotel: roomData.property?.title,
        hotel_id: roomData.property?.id,
        rooms: [{
          title: roomData?.title,
          id: roomProperty?.room_id,
          local_price: roomProperty?.total_price,
          local_price_off: roomProperty?.total_local_price_off,
          type_id: 0,
          available_rooms: 0,
          base_price: 0,
          original_sell_price: 0,
          bed_price: 0,
          child_price: 0,
          has_foreign_guest: false,
          extra_bed: 0,
          breakfast_included: false,
          adult: 0,
          child: 0,
          child_age: 0,
          infant_age: 0,
          adult_reserved: 0,
          child_reserved: 0
        }],
        is_available: roomProperty.availability > 0
      });
    };
    t2 = {
      handleTrackReserveButtonClicked
    };
    $[4] = roomData;
    $[5] = roomProperty;
    $[6] = router;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const handleFacilicyModalScrollChanged = data => {
  addEventToTracking(USER_TRACKING_EVENTS.VILLA_AMENITIES_MODAL_SCROLL_CHANGED, {
    product: "villa",
    ...data
  });
};